<template>
  <div class="header-base" id="header">
    <v-dialog v-model='dialog' persistent max-width='800'>
      <v-card>
        <v-carousel
          cycle
          interval='6000'
          height='100%'
          hide-delimiters
          show-arrows-on-hover
          v-model='popupID'
        >
          <v-carousel-item>
            <v-card-title class='headline'>Announcing the Twisty Puzzle Cup!</v-card-title>
            <v-card-text>
              <div style='text-align: left; color: rgba(0,0,0,0.9);'>
                <ul>
                <li>The Twisty Puzzle Cup is a multi-week event where competitors compete in different events to accrue points in a season's leaderboard. Events will be streamed on Twitch and a <b>$225 prize pool will be awarded to the top 10 competitors of the season.</b></li>
                <li>Each event will start with <b>open qualifiers</b> and the best averages will make it into the bracket stage. Each bracket round will be a <b>head to head</b> best of 5 (unless stated otherwise). If you lose, you are knocked out of the bracket.</li>
                <li>If you don't make it into the bracket, make sure to stick around for the stream. We'll have <b>giveaways</b>, you can ask questions to some of the best cubers in the world during <b>competitor interview</b>, and there will be all sorts of fun besides just cubing.</li>
                <li>The first open qualifiers for <b>3x3 and 3BLD</b> start <b>May 22</b> and last for 24 hours.</li>
                </ul>
              </div>
              <br/>
              <youtube videoId='eR9VmV4n_Oc' :playerWidth='1 * 640' :playerHeight='1 * 360'></youtube>
            </v-card-text>
          </v-carousel-item>
        </v-carousel>
        <v-card-actions>
          <v-btn @click='dialog = false' text><v-icon>fas fa-times</v-icon> Close</v-btn>
          <v-spacer></v-spacer>
          <v-btn v-if='popupID === 0' to='/tpc' depressed color='primary'>Learn More<v-icon style='padding-left: 10px;'>fas fa-arrow-right</v-icon></v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-layout justify-end wrap>
      <v-layout justify-start>
        <v-btn color='primary' depressed to='/'>CubersLive HOME</v-btn>
        <v-btn color='primary' depressed to='/tpc'>Twisty Puzzle Cup<v-icon small style='padding-left: 10px;'>fas fa-arrow-right</v-icon></v-btn>
        <vue-kofi uid='preetham' style='margin: 6px 0 6px 0' />
      </v-layout>
      <header-user-sessions v-if="loggedIn" />
      <header-session-settings :loggedIn="loggedIn" :pageType='pageType' @open-dialog="$emit('open-dialog')" @close-dialog="$emit('close-dialog')" />
      <header-create-session :loggedIn="loggedIn" :pageType='pageType' @open-dialog="$emit('open-dialog')" @close-dialog="$emit('close-dialog')" />
      <header-login :loggedIn="loggedIn" @open-dialog="$emit('open-dialog')" @close-dialog="$emit('close-dialog')" />
    </v-layout>
  </div>
</template>

<script>
import VueKofi from 'vue-kofi'

import HeaderUserSessions from '@/components/HeaderUserSessions'
import HeaderLogin from '@/components/HeaderLogin'
import HeaderSessionSettings from '@/components/HeaderSessionSettings'
import HeaderCreateSession from '@/components/HeaderCreateSession'

export default {
  name: 'header-base',
  data () {
    return {
      dialog: true,
      popupID: 0,
    }
  },
  props: {
    pageType: String // eg. dashboard, session, etc.
  },
  methods: {
    windowOpen (url) {
      window.open(url)
    }
  },
  computed: {
    loggedIn () {
      return this.$store.state.globalAuthToken !== '' && this.$store.state.globalAuthToken !== null && this.$store.state.globalAuthToken !== undefined
    },
    popupVersion () {
      // for tpc popup
      let v = localStorage.getItem('headerBasePopup')
      localStorage.setItem('headerBasePopup', 2) // NOTE: increment popupVersion here
      return parseInt(v || 0)
    }
  },
  created () {
    // NOTE: increment popupVersion here
    this.dialog = this.popupVersion < 2 && this.$route.params.viewerType !== 'stream' // disable this popup in streamer mode so it doesn't screw with the stream
    let globalAuthToken = localStorage.getItem('globalAuthToken')
    let globalSolver = localStorage.getItem('globalSolver')
    let globalSolverId = localStorage.getItem('globalSolverId')

    let sessionTimesSettingsStr = localStorage.getItem('sessionTimesSettings')
    let sessionTimesSettings = {}
    if (sessionTimesSettingsStr) {
      sessionTimesSettings = JSON.parse(sessionTimesSettingsStr)
    }
    this.$store.commit('setSessionTimesSettings', sessionTimesSettings)

    if (globalAuthToken && globalSolver && globalSolverId) {
      const sessionSolverId = localStorage.getItem('solverId:' + this.$store.state.sessionId)
      if (this.pageType !== 'session' || (this.pageType === 'session' && (globalSolverId === sessionSolverId || sessionSolverId === null))) {
        this.$store.commit('setGlobalAuthToken', globalAuthToken)
        this.$store.commit('setSolver', globalSolver)
        this.$store.commit('setSolverId', globalSolverId)
      }
    }
  },
  components: {
    VueKofi,
    HeaderUserSessions,
    HeaderLogin,
    HeaderSessionSettings,
    HeaderCreateSession
  }
}
</script>

<style scoped>
#header {
  background-color: #f0f0f0;
  padding-top: 20px;
  padding-bottom: 20px;
  margin-bottom: 10px;
}

::v-deep .v-btn {
  margin: 6px 8px !important;
}
</style>
